<template>
    <a 
        v-if="anchorId"
        :id="anchorId"
        class="anchor"
    />
</template>

<script setup>
defineProps({
    anchorId: {
        type: String,
        required: true
    }
});
</script>
